import {getExcerpt, isHex} from '../helpers/StringHelper';

export class SecureAuthComponent {
  data = {
    default: {
      window: {
        companyName: typeof SECURE_AUTH_DATA === 'undefined' ? '?' : SECURE_AUTH_DATA.window.company_name,
        message: typeof SECURE_AUTH_DATA === 'undefined' ? 'Your Message Goes Here' : SECURE_AUTH_DATA.window.message
      }
    }
  };

  container = document.querySelector('.secure-auth-shortcode-wrapper');

  constructor() {
    if (!this.container) {
      return;
    }

    this.addEventListeners();
  }

  addEventListeners() {
    const companyName = this.container.querySelector('#secure-auth-company-name');
    if (companyName) {
      companyName.addEventListener('input', (e) => this.companyNameInputHandler(e));
    }

    const message = this.container.querySelector('#secure-auth-message');
    if (message) {
      message.addEventListener('input', (e) => this.messageInputHandler(e));
    }

    const mainColor = this.container.querySelector('#secure-auth-main-color');
    if (mainColor) {
      mainColor.addEventListener('input', (e) => this.mainColorInputHandler(e));
    }

    const mainColorText = this.container.querySelector('input[name=main_color_text]');
    if (mainColorText) {
      mainColorText.addEventListener('input', (e) => this.mainColorTextInputHandler(e));
    }

    const accentColor = this.container.querySelector('#secure-auth-accent-color');
    if (accentColor) {
      accentColor.addEventListener('input', (e) => this.accentColorInputHandler(e));
    }

    const accentColorText = this.container.querySelector('input[name=accent_color_text]');
    if (accentColorText) {
      accentColorText.addEventListener('input', (e) => this.accentColorTextInputHandler(e));
    }
  }

  companyNameInputHandler(e) {
    const target = e.target;
    this.setCompanyName(target.value);
  }

  messageInputHandler(e) {
    const target = e.target;
    this.setMessage(target.value);
  }

  mainColorInputHandler(e) {
    const target = e.target;
    this.updateInputValue('input[name=main_color_text]', target.value);
    this.setBackgroundColor(target.value);
  }

  mainColorTextInputHandler(e) {
    const target = e.target;

    if (!isHex(target.value)) {
      return;
    }

    this.updateInputValue('#secure-auth-main-color', target.value);
    this.setBackgroundColor(target.value);
  }

  accentColorInputHandler(e) {
    const target = e.target;
    this.updateInputValue('input[name=accent_color_text]', target.value);
    this.setAccentColors(target.value);
  }

  accentColorTextInputHandler(e) {
    const target = e.target;

    if (!isHex(target.value)) {
      return;
    }

    this.updateInputValue('#secure-auth-accent-color', target.value);
    this.setAccentColors(target.value);
  }

  setCompanyName(name) {
    const companyNameElement = this.container.querySelector('.auth-window__company-name .initials');
    if (!companyNameElement) {
      return;
    }

    if (name.length === 0) {
      companyNameElement.innerText = this.data.default.window.companyName;

      return;
    }

    companyNameElement.innerText = name.length < 3
      ? name
      : name.substr(0, 2);
  }

  setMessage(message) {
    const messageElement = this.container.querySelector('.auth-window__message');
    if (!messageElement) {
      return;
    }

    messageElement.innerText = message.length === 0
      ? this.data.default.window.message
      : getExcerpt(message);
  }

  setBackgroundColor(color) {
    const authWindow = this.container.querySelector('.auth-window');
    if (!authWindow) {
      return;
    }

    authWindow.style.backgroundColor = color;
  }

  setAccentColors(color) {
    const companyName = this.container.querySelector('.auth-window__company-name');
    if (companyName) {
      companyName.style.backgroundColor = color;
    }

    const clockSvg = this.container.querySelector('.auth-window-list svg.clock');
    if (clockSvg) {
      const clockCircle = clockSvg.querySelector('path.circle');
      if (clockCircle) {
        clockCircle.style.fill = color;
      }

      const clockHands = clockSvg.querySelector('path.hands');
      if (clockHands) {
        clockHands.style.stroke = color;
      }
    }

    const laptopSvg = this.container.querySelector('.auth-window-list svg.laptop');
    if (laptopSvg) {
      const laptopScreen = laptopSvg.querySelector('path.screen');
      if (laptopScreen) {
        laptopScreen.style.fill = color;
      }

      const laptopKeyboard = laptopSvg.querySelector('path.keyboard');
      if (laptopKeyboard) {
        laptopKeyboard.style.stroke = color;
      }
    }

    const approveButton = this.container.querySelector('.button_approve');
    if (approveButton) {
      approveButton.style.backgroundColor = color;
    }
  }

  updateInputValue(selector, value) {
    const input = this.container.querySelector(selector);
    if (input) {
      input.value = value;
    }
  }
}